module.exports = __webpack_public_path__ + "static/media/shorts.83352393.png";